import { render, staticRenderFns } from "./ScreeningQuestionsList.vue?vue&type=template&id=6fde2ed0&scoped=true"
import script from "./ScreeningQuestionsList.vue?vue&type=script&lang=ts"
export * from "./ScreeningQuestionsList.vue?vue&type=script&lang=ts"
import style0 from "./ScreeningQuestionsList.vue?vue&type=style&index=0&id=6fde2ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fde2ed0",
  null
  
)

export default component.exports